/**
 * Кнопка-гамбургер, переключатель модильного меню.
 *
 * @author      delphinpro <delphinpro@gmail.com>
 * @copyright   copyright © 2018 delphinpro
 * @license     licensed under the MIT license
 */

import hamburgerButton from 'hamburger-button';


function initHamburger() {
    return hamburgerButton({
        mainClass       : 'hamburger',              // by default
        stateActiveClass: 'hamburger_state_active', // by default
        onOpen() {
            document.body.classList.add('locked');
            document.querySelector('.navi').classList.add('is-open');
            document.querySelector('.navi__menu').scrollTop = 0;
        },
        onClose() {
            document.body.classList.remove('locked');
            document.querySelector('.navi').classList.remove('is-open');
        },
    });
}

export default initHamburger;
